import type { URLGroupPatternType } from "@amethyst/ai-tools";

export {
  type URLGroupPatternType,
  urlGroupPatternTypeEnum,
} from "@amethyst/ai-tools";

import { msg } from "@lingui/core/macro";

// 再利用可能な URLGroupPatternType 定義とラベル（GraphQL enumに対応）

export const URLGroupPatternTypeLabels: Record<
  URLGroupPatternType,
  ReturnType<typeof msg>
> = {
  CONTAINS: msg`Contains`,
  INCLUDES: msg`Contains`,
  NOT_INCLUDES: msg`Does not contain`,
  NOT_CONTAINS: msg`Does not contain`,
  STARTS_WITH: msg`Starts with`,
  ENDS_WITH: msg`Ends with`,
  EQUALS: msg`Equals`,
  REGEX: msg`Regex`,
  NOT_REGEX: msg`Does not match regex`,
  SUB_DOMAIN: msg`Sub domain is`,
  DEPTH1: msg`First path is`,
  DEPTH2: msg`Second path is`,
  DEPTH3: msg`Third path is`,
};
